import { DropdownOption } from '../../../types/dropdown';

// Enums for type safety
export enum CategoryId {
  GENERAL = 'general',
  SPECIFIC = 'specific'
}

export enum LeadSourceId {
  WHATSAPP = 'whatsapp',
  FACEBOOK = 'facebook',
  WEBSITE = 'website',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  EMAIL = 'email'
}

export enum AssigneeId {
  JOHN_DOE = 'john-doe',
  JANE_SMITH = 'jane-smith',
  MIKE_JOHNSON = 'mike-johnson'
}

export enum LeadStatusId {
  NEW = 'new',
  CONTACTED = 'contacted',
  QUALIFIED = 'qualified',
  PROPOSAL_SENT = 'proposal-sent',
  NEGOTIATION = 'negotiation',
  CLOSED_WON = 'closed-won',
  CLOSED_LOST = 'closed-lost'
}

export enum PriorityId {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export enum LeadSectionId {
  TAGS = 'tags',
  ASSIGNEES = 'assignees',
  STATUS = 'status',
  LEADS = 'leads'
}

export const priorityOptions: DropdownOption[] = [
  { id: PriorityId.LOW, label: 'Low', value: PriorityId.LOW },
  { id: PriorityId.MEDIUM, label: 'Medium', value: PriorityId.MEDIUM },
  { id: PriorityId.HIGH, label: 'High', value: PriorityId.HIGH },
  { id: PriorityId.URGENT, label: 'Urgent', value: PriorityId.URGENT }
];

export const getOptionByValue = (
  options: DropdownOption[],
  value: string
): DropdownOption | undefined =>
  options.find((option) => option.value === value);

export const getOptionById = (
  options: DropdownOption[],
  id: string
): DropdownOption | undefined => options.find((option) => option.id === id);
